import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FlowsService } from 'src/app/contexts/snapshot/flows.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-flow-change-name-modal.component',
  templateUrl: './flow-change-name-modal.component.html',
  styleUrls: ['./flow-change-name-modal.component.scss']
})
export class FlowChangeNameModalComponent implements OnInit {
  form: FormGroup;
  model: any = {};
  showAdvancedSettings = false;

  constructor(private fb: FormBuilder,
    private userService: UserService,
    private flowsService: FlowsService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<FlowChangeNameModalComponent>,
  ) { }

  ngOnInit(): void {
    this.initializeModel();
    this.initializeForm();
  }

  private initializeModel(): void {
    this.model = {
      ...this.model,
      ...this.data,
      open: true
    };

    this.model.user = this.userService.getUser();

  }

  private initializeForm(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(32)]],
      description: ['', [Validators.maxLength(100)]],
      flow_type_id: ['']
    });

    this.form.patchValue({
      name: this.model.name,
      description: this.model.description,
      flow_type_id: this.model.flow_version?.flow?.flow_type_id?.toString() || '0'
    });

    if (this.model.isDefault) {
      this.form.disable();
    }
  }

  inputFormValidation() {
    this.form.get('name')?.setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(32)]);
    this.form.get('name')?.updateValueAndValidity();
    this.form.get('description')?.setValidators([Validators.maxLength(100)]);
    this.form.get('description')?.updateValueAndValidity();
  }

  submit($event) {

    this.inputFormValidation();


    if (this.model.flow_version.authorization_scheme_id != null &&
      this.form.get('flow_type_id')?.value == "1"
    ) {
      this.toastr.error(
        this.translateService.instant('flows.modal.change.error_as')
      );
    }
    else {

      if (this.form.valid) {

        var param = {
          name: this.form.get('name')?.value,
          description: this.form.get('description')?.value,
          flow_id: this.model.flow_id,
          snapshot_id: this.model.snapshot_id,
          selector_test_id: this.model.selector_test_id,
          order_id: this.model.order,
          flow_type_id: this.form.get('flow_type_id')?.value
        };

        this.flowsService
          .change(this.model.partner, this.model.account, param)
          .subscribe((response) => {
            this.toastr.success(
              this.translateService.instant('flows.modal.change.success')
            );
            this.dialogRef.close(response);
          },
            (error) => {
              console.log("error");
              if (error.result)
                if (error.result.length > 0) {
                  error.result.forEach(element => {

                    this.toastr.error(element.message);
                  });
                }


            });
      }
    }
  }


  toggleAdvancedSettings(): void {
    this.showAdvancedSettings = !this.showAdvancedSettings;
  }

  close() {
    this.dialogRef.close();
  }

  reset(): void {

    var definition = {};
    var flow = {
      flow_id: this.model.flow_version.flow_id,
      version: this.model.flow_version.version,
      authorization_scheme_id: null,
      definition: JSON.stringify(definition)
    };
    this.flowsService.save(this.model.partner, this.model.account, flow)
      .subscribe({
        next: (response) => {
          this.toastr.success(this.translateService.instant('flows.modal.reset.success'));
          this.dialogRef.close(response);
        },
        error: (error) => {
          console.error("Error:", error);

          if (error?.result?.length) {
            error.result.forEach((element: { message: string }) => {
              this.toastr.error(element.message);
            });
          }
        }
      });
  }
  // const param = {
  //   flow_id: this.model.flow_version.flow_id,
  //   version: this.model.flow_version.version
  // };

  // this.flowsService.reset(this.model.partner, this.model.account, param)
  //   .subscribe({
  //     next: (response) => {
  //       this.toastr.success(this.translateService.instant('flows.modal.reset.success'));
  //       this.dialogRef.close(response);
  //     },
  //     error: (error) => {
  //       console.error("Error:", error);

  //       if (error?.result?.length) {
  //         error.result.forEach((element: { message: string }) => {
  //           this.toastr.error(element.message);
  //         });
  //       }
  //     }
  //   });



}

